<div class="input-area-wrapper">
  <div
    class="input-area sensor-map-dropdown"
    [class.searchFilled]="searchString() !== ''"
    [class.mobile]="isMobile()"
  >
    <input
      #searchInput
      nz-input
      [nzAutocomplete]="auto"
      [ngModel]="searchString()"
      (ngModelChange)="
        searchString.set($event); searchStringUpdate$.next($event)
      "
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      [placeholder]="i18n.langString('street_or_building')"
      (input)="onTextInput($event)"
      class="regular"
    />
    <button class="search-btn" aria-label="search">
      <i
        nz-icon
        nzType="icons:search"
        class="svg-icon search-icon noMarginRight multicolorIcon"
        [class.fillwhite]="searchString() !== ''"
      ></i>
    </button>

    <nz-autocomplete #auto>
      @for (res of searchResults(); track res.fulltext) {
        <nz-auto-option
          [nzValue]="res.value"
          [nzLabel]="res.fulltext"
          class="sensor-map-dropdown"
        >
          <div class="label regular">
            <span class="search-term">{{ res.searchTerm }}</span
            >{{ res.label }}
          </div>
          <div class="description detail">{{ res.description }}</div>
        </nz-auto-option>
      }

      <nz-auto-option
        [nzValue]="''"
        [nzLabel]="''"
        class="set-location-option body-bold"
      >
        <div>
          <i
            nz-icon
            [nzType]="'icons:location'"
            class="svg-icon big-icon fillblackcoral"
          ></i>
          <span>{{ i18n.langString("set_location_on_map") }}</span>
        </div>
      </nz-auto-option>
    </nz-autocomplete>
  </div>
</div>

<div class="map">
  <app-map
    [class.desktop]="false"
    [sensors]="sensors()"
    [showSensors]="showSensors()"
    [satelliteView]="satelliteView()"
    [center]="startLocation()"
    [position]="sensorPosition()"
    [userLocation]="userLocation()"
    [showPosition]="showSensorPosition()"
    (positionChanged)="onPositionChanged($event)"
  ></app-map>
</div>

<div class="map-bottom-buttons">
  @if (satelliteView()) {
    <app-nav-button
      (clickEvent)="satelliteView.set(false)"
      [lighttertiary]="true"
      [whiteBG]="true"
      [svgIcon]="'icons:map'"
      class="additionalMapBtns btn-not-wide"
      [bodyBold]="true"
      [wide]="false"
      [smol]="true"
    >
      {{ i18n.langString("map_view") }}
    </app-nav-button>
  } @else {
    <app-nav-button
      (clickEvent)="satelliteView.set(true)"
      [lighttertiary]="true"
      [whiteBG]="true"
      [svgIcon]="'icons:satellite'"
      class="additionalMapBtns btn-not-wide"
      [bodyBold]="true"
      [wide]="false"
      [smol]="true"
    >
      {{ i18n.langString("satellite_view") }}
    </app-nav-button>
  }

  <app-nav-button
    [lighttertiary]="true"
    class="additionalMapBtns showSensorBtn btn-not-wide"
    [bodyBold]="true"
    [whiteBG]="true"
    [wide]="false"
    [smol]="true"
  >
    {{ i18n.langString("show_sensors") }}
    <nz-switch
      [ngModel]="showSensors()"
      (ngModelChange)="showSensors.set($event)"
    ></nz-switch>
  </app-nav-button>
</div>
